export const BasicCell = ({getValue, column}) => {
	const value = getValue()
	const {columnDef} = column
	const {format} = columnDef

	if (format) return format(value)

	return value || null
}

export const BasicWithZeroCell = ({getValue}) => {
	const value = getValue()

	if (value || value === 0) return value
	return null
}
